import { render, staticRenderFns } from "./files.vue?vue&type=template&id=28dab268&scoped=true&lang=html&"
import script from "./files.vue?vue&type=script&lang=js&"
export * from "./files.vue?vue&type=script&lang=js&"
import style0 from "./files.vue?vue&type=style&index=0&id=28dab268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dab268",
  null
  
)

export default component.exports